import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LandingPage, Welcome, Register, Error, ProtectedRoute, EmailVerification } from "./pages"
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AddBooks, Accounts, Stats, SharedLayout, Profile } from './pages/Dashboard'
import SubscriptionPlans from './pages/Dashboard/Subscription';
import PaymentSuccess from './pages/Dashboard/payment/PaymentSuccess';
import PaymentCancelled from './pages/Dashboard/payment/PaymentCancelled';
import PrivacyPolicy from './pages/Dashboard/PrivacyPolicy';
import PrivacyPolicyOpen from './pages/Dashboard/PrivacyPolicyOpen';
import BooksEntryRouter from './pages/Dashboard/Books/BooksEntryRouter';
import PreviewSelectedOwnBook from './pages/Dashboard/Books/PreviewSelectedOwnBook';
import OwnBooksList from './pages/Dashboard/Books/OwnBooksList';
import OwnBookDetails from './pages/Dashboard/Books/OwnBookDetails';
import Terms from './pages/Dashboard/Terms';
import Settings from './pages/Dashboard/Settings';
import QrGenerator from './pages/Dashboard/QrGenerator';
import TermsOpen from './pages/Dashboard/TermsOpen';
import SupportOpen from './pages/Dashboard/SupportOpen';
import DMCAOpen from './pages/Dashboard/DMCAOpen';
import {
    LmsDashboardPage,
    LmsLoginPage,
    LmsProtectedRoute,
    LmsRegisterPage,
    LmsVerifyEmailPage,
} from './features/lms';
import {
    CreateStudentPage,
    EditStudentPage,
    StudentDetailsPage,
    StudentsPage,
} from './features/lms/students';

const App = () => (
    <BrowserRouter>
        <Routes>
            <Route path='/' element={
                <ProtectedRoute>
                    <SharedLayout />
                </ProtectedRoute>
            }>
                <Route index element={<BooksEntryRouter fallback='selector' />} />
                <Route path='add-books/:bookId' element={<AddBooks />} />
                <Route path='own-books' element={<OwnBooksList />} />
                <Route path='own-books/:bookId' element={<OwnBookDetails />} />
                <Route path='all-accounts' element={<Accounts />} />
                <Route path='all-stats' element={<Stats />} />
                <Route path='profile' element={<Profile />} />
                <Route path='subscription' element={<SubscriptionPlans />} />
                <Route path='privacy-policy' element={<PrivacyPolicy />} />
                <Route path='terms' element={<Terms />} />
                <Route path='settings' element={<Settings />} />
                <Route path='settings/qr' element={<QrGenerator />} />
            </Route>
            <Route path='/landing' element={<LandingPage />} />
            <Route path='/welcome' element={<Welcome />} />
            <Route path='/books/search-own' element={<BooksEntryRouter fallback='own' />} />
            <Route path='books/preview-own/:bookId' element={<PreviewSelectedOwnBook />} />
            <Route path='subscription/success' element={<PaymentSuccess />} />
            <Route path='subscription/cancel' element={<PaymentCancelled />} />

            <Route path='register' element={<Register />} />
            <Route path='/verify-email' element={<EmailVerification />} />
            <Route path='/lms/register' element={<LmsRegisterPage />} />
            <Route path='/lms/login' element={<LmsLoginPage />} />
            <Route path='/lms/verify-email' element={<LmsVerifyEmailPage />} />
            <Route
                path='/dashboard/*'
                element={
                    <LmsProtectedRoute>
                        <LmsDashboardPage />
                    </LmsProtectedRoute>
                }
            >
                <Route path='students' element={<StudentsPage />} />
                <Route path='students/new' element={<CreateStudentPage />} />
                <Route path='students/:studentId' element={<StudentDetailsPage />} />
                <Route path='students/:studentId/edit' element={<EditStudentPage />} />
            </Route>
            <Route path='/privacypolicy' element={<PrivacyPolicyOpen />} />
            <Route path='/termscondition' element={<TermsOpen />} />
            <Route path='/support' element={<SupportOpen />} />
            <Route path='/dmca' element={<DMCAOpen />} />
            <Route path='*' element={<Error />} />
        </Routes>
        <ToastContainer position='top-center' />
    </BrowserRouter>
)
export default App;
